export default {
  name: '홈앤쇼핑어시스턴트-데모',
  header: '홈앤쇼핑어시스턴트-데모',
  thumbnail: {
    bot: `/assets/hnsmall/hnsmall_chat_ai.png`,
    user: `/assets/me.png`,
  },
  palette: {
    primary: '#2196F3', // 홈앤쇼핑 메인 브랜드 컬러 (파란색 계열)
    primary10: '#E3F2FD', // 홈앤쇼핑 연한 하늘색 계열
  },
  introduction:
    '쇼핑에 대한 모든 것을 알려드릴게요.\n무엇을 질문할지 모르겠다면, 아래 질문을 눌러보세요.',
  notice:
    '홈앤쇼핑어시스턴트는 OpenAI가 제공하는 서비스를 활용하는 것으로 이용 시 입력되는 데이터는 OpenAI에도 제공되며, 제공 이후 OpenAI의 데이터 관리 정책에 따라 관리됩니다. 또한 고객님의 소중한 개인정보 보호를 위해 홈앤쇼핑어시스턴트 이용 시 개인정보는 입력하지 않도록 주의 바랍니다.',
  madeBy: 'presented by BUZZNI',
  sdk_title: '홈앤쇼핑어시스턴트-데모',
};
